module.exports = __webpack_public_path__ + "img/dbg_logo241113_mid.5e306904.svg";